<template>
  <v-form v-model="valid" ref="mainForm">
    <div v-if="lieuInspectionModifiable">
      <ressource :code="'choisir-lieu-inspection'" />
      <div v-for="lieuExercice in lieuxExercicesInspections" :key="lieuExercice.id" >        
        <v-card class="mb-3 pa-4" outlined>
          <OrganisationCardContent :organisation="lieuExercice.adresse" />
          <CaseACocher
            code="accepter_lieu_inspection"
            v-model="lieuExercice.selectionne"
            :ref="`selection${lieuExercice.id}`"
            @input="organisationSelected(lieuExercice.adresse, $event)"
          />
        </v-card>
      </div>
    </div> 
    <div v-if="lieuInspectionSelectionne">
      <ressource :code="'lieu-inspection-description'"/>
      <OrganisationCardContent :organisation="sasPriseRendezvousInspection.lieuInspectionSelectionne"/>
    </div>
    <CaseACocherLive
      code="aucun_lieu_inspection"
      v-model="sasPriseRendezvousInspection.aucunLieuDInspection"
      :live="liveSasPriseRendezvousInspection(33104, sasPriseRendezvousInspection)" 
      @input="aucunLieuDInspectionSelected($event)"
      ref="aucunLieuDInspection"
    />
    <ressource 
      :code="'aucun-lieu-inspection-selectionne'"
      v-if="sasPriseRendezvousInspection.aucunLieuDInspection"
    />  
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent.vue"
import { Queue, Api } from "@/plugins/api"
import LieuExercice from '@/models/LieuExercice'

export default {
  mixins: [StepFormWithValidation],
  components: { OrganisationCardContent },
  props: {
    sas: { type: Object },
  },
  computed: {
    sasPriseRendezvousInspection() {
      return this.sas.sasPriseRendezvousInspection
    },
    lieuxExercicesInspections() {
      return this.sas.lieuxExercicesInspections
    },
    hasNoLieuxExercicesInspections() {
      return !this.lieuxExercicesInspections || this.lieuxExercicesInspections.length === 0
    },
    isValid() {
      if (!this.valid) {
        return false
      }
      if (!this.lieuInspectionModifiable) {
        return true
      }
      
      const atLeastOneLieuSelected = this.lieuxExercicesInspections.some(lieu => lieu.selectionne)
      const aucunLieuChecked = this.sasPriseRendezvousInspection.aucunLieuDInspection
      
      return atLeastOneLieuSelected || aucunLieuChecked
    },
    lieuInspectionModifiable() {
      return this.sas.sasPriseRendezvousInspection.lieuInspectionModifiable
    },
    lieuInspectionSelectionne() {
      return this.sasPriseRendezvousInspection.lieuInspectionSelectionne?.organisationId != null
    }
  },
  watch: {
    isValid() {
      this.$emit("validation-changed", this.isValid)
    }
  },
  methods: {
    liveSasPriseRendezvousInspection(cle, item) {
      return { endpoint: "sas-prise-rendez-vous-inspection", cle: cle, fileId: item.id }
    },
    organisationSelected(organisation, isChecked) {
      this.lieuxExercicesInspections.forEach((lieu) => {
        if (lieu.adresse.organisationId !== organisation.organisationId) {
          lieu.selectionne = false
        }
      })
      Queue.enqueue(() =>
        // On enregistre le lieu d'inspection sélectionné dans la sas
        Api.post("sas-prise-rendez-vous-inspection", {
          fileId: this.sasPriseRendezvousInspection.id,
          cle: 33103,
          value: isChecked ? organisation.organisationId : null,
        }).then(() => {
          if (isChecked) {
            this.$set(this.sasPriseRendezvousInspection, 'lieuInspectionSelectionne', organisation)
            this.$refs.aucunLieuDInspection.setValue(false)
          }
          else {
            this.$set(this.sasPriseRendezvousInspection, 'lieuInspectionSelectionne', new LieuExercice())
          }
        }),
      )
      
    },
    aucunLieuDInspectionSelected(isChecked) {
      if (this.lieuInspectionModifiable && isChecked) {
        this.lieuxExercicesInspections.forEach((lieu) => {
          lieu.selectionne = false
        })
        Queue.enqueue(() =>
          Api.post("sas-prise-rendez-vous-inspection", {
            fileId: this.sasPriseRendezvousInspection.id,
            cle: 33103,
            value: null,
          }).then(() => {
            this.$set(this.sasPriseRendezvousInspection, 'lieuInspectionSelectionne', new LieuExercice())
          }),
        )
      }
      if (isChecked) {
        this.viderRencontres()
      }
    },
    viderRencontres() {
      const rencontres = this.sas.sasRencontresInspection || []
      const champs = [
        { cle: 33006, prop: "proposition1Acceptee" },
        { cle: 33009, prop: "proposition2Acceptee" },
        { cle: 33012, prop: "proposition3Acceptee" },
        { cle: 33013, prop: "aucunePropositionAcceptee" },
      ]
      rencontres.forEach((rencontre) => {
        champs.forEach(({ cle, prop }) => {
          if (rencontre[prop]) {
            this.$set(rencontre, prop, false)
            Queue.enqueue(() =>
              Api.post("sas-rencontre-inspection", {
                fileId: rencontre.id,
                cle: cle,
                value: false,
              }),
            )
          }
        })
      })
    },
  },
}
</script>
